// extracted by mini-css-extract-plugin
export var black = "_e-6";
export var brand = "_e-1";
export var ddefault = "_e-0";
export var error = "_e-3";
export var gray = "_e-2";
export var highContrast = "_e-8";
export var outline = "_e-7";
export var success = "_e-5";
export var warning = "_e-4";